import { apiFetch } from "./api";
import type { PagedResult } from "./clients-accounts";

// ============================================================================
// DTOs (mirror src/Allmark.Contracts/Quotes/ApprovedQuoteListItemDto.cs)
// ============================================================================

export interface ApprovedQuoteListItem {
  quoteId: number;
  quoteRef: string;
  clientId: number | null;
  clientDisplay: string | null;
  ownerEmployeeId: number | null;
  ownerEmployeeName: string | null;
  description: string | null;
  approvedAtUtc: string | null;
  validUntil: string | null;
  totalIncGst: number | null;
}

export const approvedQuotesApi = {
  list: (page = 1, pageSize = 25): Promise<PagedResult<ApprovedQuoteListItem>> =>
    apiFetch<PagedResult<ApprovedQuoteListItem>>(`/api/quotes/approved?page=${page}&pageSize=${pageSize}`),
};
